"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInfoBoxMachine = exports.createInfoListBoxMachineConfig = void 0;
// TODO: convert this machine to typescript (https://kyruus.jira.com/browse/KENG-32833)
const xstate_1 = require("xstate");
const states_1 = require("../constants/states");
const events_1 = require("../constants/events");
const utils_1 = require("./utils");
const actions = {
    updateTerm: (0, xstate_1.assign)((ctx, evt) => {
        const items = (0, utils_1.filteredItems)(ctx.items, evt.data.term);
        return {
            term: evt.data.term,
            filteredItems: items,
            columns: (0, utils_1.splitList)(items, ctx.numColumns)
        };
    }),
    // update columns to remove truncation
    expandColumns: (0, xstate_1.assign)({
        columns: (ctx) => (0, utils_1.splitList)((0, utils_1.filteredItems)(ctx.items, ctx.term), ctx.numColumns)
    }),
    // update columns so that each column has at max truncateAt items
    contractColumns: (0, xstate_1.assign)({
        columns: (ctx) => (0, utils_1.splitList)((0, utils_1.filteredItems)(ctx.items, ctx.term), ctx.numColumns, ctx.truncateAt)
    }),
    clearTerm: (0, xstate_1.assign)({
        term: '',
        filteredItems: (ctx) => ctx.items,
        columns: (ctx) => (0, utils_1.splitList)(ctx.items, ctx.numColumns, ctx.truncateAt)
    })
};
const guards = {
    isExpandable: (ctx) => ctx.items.length > ctx.truncateAt,
    hasResultsForTerm: (ctx, event) => {
        const term = event.data.term;
        return (0, utils_1.filteredItems)(ctx.items, term).length > 0;
    },
    termIsEmpty: (ctx, event) => {
        const term = event.data.term;
        return (term || '').length === 0;
    }
};
const createInfoListBoxMachineConfig = (items = [], truncateAt, numColumns) => ({
    initial: states_1.states.routing,
    context: {
        // full items list
        items,
        // list of items to exceed to enable 'show more'
        truncateAt,
        numColumns,
        columns: (0, utils_1.splitList)(items, numColumns),
        term: '',
        filteredItems: items
    },
    states: {
        [states_1.states.routing]: {
            always: [
                {
                    cond: 'isExpandable',
                    target: states_1.states.expandable
                },
                {
                    target: states_1.states.unexpandable
                }
            ]
        },
        [states_1.states.unexpandable]: {},
        [states_1.states.expandable]: {
            initial: states_1.states.contracted,
            states: {
                [states_1.states.contracted]: {
                    entry: ['contractColumns'],
                    on: {
                        [events_1.events.SHOW_MORE]: {
                            target: states_1.states.expanded
                        }
                    }
                },
                [states_1.states.expanded]: {
                    entry: ['expandColumns'],
                    on: {
                        [events_1.events.SHOW_LESS]: {
                            target: states_1.states.contracted
                        }
                    }
                }
            }
        },
        [states_1.states.searching]: {},
        [states_1.states.noResults]: {}
    },
    on: {
        [events_1.events.UPDATE_TERM]: [
            {
                cond: 'termIsEmpty',
                actions: ['updateTerm'],
                target: states_1.states.routing
            },
            {
                cond: 'hasResultsForTerm',
                actions: ['updateTerm'],
                target: states_1.states.searching
            },
            {
                actions: ['updateTerm'],
                target: states_1.states.noResults
            }
        ],
        [events_1.events.CLEAR_TERM]: {
            actions: ['clearTerm'],
            target: states_1.states.routing
        }
    }
});
exports.createInfoListBoxMachineConfig = createInfoListBoxMachineConfig;
const createInfoBoxMachine = (items, truncateAt, numColumns) => {
    return (0, xstate_1.createMachine)((0, exports.createInfoListBoxMachineConfig)(items, truncateAt, numColumns)).withConfig({
        actions,
        guards
    });
};
exports.createInfoBoxMachine = createInfoBoxMachine;
//# sourceMappingURL=providerInfoListBoxMachine.js.map